import { createContext, useContext } from 'react';
import { type State } from '@ordergroove/smi-store/types';

type Subscription = State['subscriptions'][number];

export const SubscriptionContext = createContext<Subscription | null>(null);

export function useSubscriptionContext() {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscriptionContext must be used within SubscriptionContext.Provider');
  }
  return context;
}
